import { render, staticRenderFns } from "./GenerateTkButtonsFromOIK.vue?vue&type=template&id=3920b342&scoped=true&"
import script from "./GenerateTkButtonsFromOIK.vue?vue&type=script&lang=ts&"
export * from "./GenerateTkButtonsFromOIK.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateTkButtonsFromOIK.vue?vue&type=style&index=0&id=3920b342&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920b342",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
